var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 253.316,
    height: 193.286,
    viewBox: "0 0 253.316 193.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_794",
    "data-name": "Grupo 794",
    transform: "translate(-6897.948 -1692.906)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2344",
    "data-name": "Caminho 2344",
    d: "M391.883,2298.646a11.555,11.555,0,0,1,0,16.341L258.97,2447.775a13.565,13.565,0,0,1-19.172,0l-68.468-68.339a11.557,11.557,0,0,1,0-16.341l26.29-26.292a11.548,11.548,0,0,1,16.34,0l27.256,27.253a11.553,11.553,0,0,0,16.34,0l91.7-91.7a11.553,11.553,0,0,1,16.34,0Z",
    transform: "translate(6730.002 -565.55)",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2345",
    "data-name": "Caminho 2345",
    d: "M391.883,2298.646a11.555,11.555,0,0,1,0,16.341L258.97,2447.775a13.565,13.565,0,0,1-19.172,0l-68.468-68.339a11.557,11.557,0,0,1,0-16.341l26.29-26.292a11.548,11.548,0,0,1,16.34,0l27.256,27.253a11.553,11.553,0,0,0,16.34,0l91.7-91.7a11.553,11.553,0,0,1,16.34,0Z",
    transform: "translate(6751.997 -572.067)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyComplete);
export default __webpack_public_path__ + "static/media/verify-complete.63acff6ffd4f91f3def52cdaab580795.svg";
export { ForwardRef as ReactComponent };